<template>
  <v-layout v-resize="onResize" column>
    <div>
      <template v-if="!$route.meta.allowAnonymous">
        <template v-if="isMobile || isApp">
          <v-app style="background: #f5f5f5">
            <navbar />
            <v-main class="mb-15">
              <router-view></router-view>
            </v-main>
            <BottomNavigation />
          </v-app>
        </template>
        <template v-else>
          <v-app style="background: #f5f5f5">
            <navbar />
            <v-main>
              <router-view></router-view>
            </v-main>
          </v-app>
        </template>
      </template>
      <template v-else>
        <transition>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </transition>
      </template>
    </div>
  </v-layout>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import navbar from "./views/navbar.vue";
import BottomNavigation from "./views/BottomNavigation.vue";
export default {
  name: "App",

  components: {
    navbar,
    BottomNavigation,
  },

  data() {
    return {
      isMobile: false,
      isApp: false,
    };
  },
  mounted() {
    const isInStandaloneMode = () =>
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone ||
      document.referrer.includes("android-app://");
    if (isInStandaloneMode()) {
      //console.log("webapp is installed");
      this.isApp = true;
    }
  },
  methods: {
    onResize() {
      if (window.innerWidth < 960) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>
